import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from 'utils/auth';
import { RedirectLoginOptions } from '@auth0/auth0-react';

import { SFTY_STORAGE_KEY } from 'hooks/useIsSFTYUser';
import config from 'config';

const { connection } = config;

export const useLogin = () => {
  const { isAuthenticated, loginWithRedirect, isLoading } = useAuth();
  const location = useLocation();
  const returnTo = (): string => `${location.pathname}${location.search}`;
  const loginOptions: RedirectLoginOptions = {
    connection,
  };

  useEffect(() => {
    if (isLoading || isAuthenticated) {
      return;
    }

    // Auth finished loading with no session (expired, or never signed in):
    // drop any SFTY marker left from a previous login before the next one
    // starts. An incoming ?isSFTYUser=true is kept in the returnTo URL below,
    // so it is re-applied after login.
    sessionStorage.removeItem(SFTY_STORAGE_KEY);

    const opts = {
      ...loginOptions,
      fragment: null,
      appState: {
        ...loginOptions.appState,
        returnTo: typeof returnTo === 'function' ? returnTo() : returnTo,
      },
    };

    (async (): Promise<void> => {
      await loginWithRedirect(opts);
    })();
  }, [isLoading, isAuthenticated]);
};
